module.exports = __webpack_public_path__ + "img/aufzugoMaintenanceBannerMobile.4ff5fe8.webp";